export default __webpack_public_path__ + "static/media/materialediconsumoLogo.e1181997.png";